import { Link } from "react-router-dom";
import { useSite } from "@/lib/site";
import { telHref } from "@/lib/api";
import { Logo } from "./Logo";

export const SiteFooter = () => {
  const { cfg } = useSite();
  const b = cfg.business;
  return (
    <footer className="mt-20 bg-brand-navy text-slate-300" data-testid="site-footer">
      <div className="mx-auto grid max-w-6xl gap-8 px-4 py-12 text-sm sm:px-6 md:grid-cols-3">
        <div>
          <Logo light />
          <p className="mt-5 text-slate-300">{b.name}<br />{b.address}</p>
          <p className="mt-2"><a className="font-medium text-white hover:underline" href={telHref(b.phone)} data-testid="footer-phone-link">{b.phone}</a></p>
          <p><a className="font-medium text-white hover:underline" href={`mailto:${b.email}`} data-testid="footer-email-link">{b.email}</a></p>
        </div>
        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-brand-silver">Our website</p>
          <p><a className="font-medium text-white hover:underline" href={b.website} data-testid="footer-website-link">hcsales.co.uk</a> – our main website</p>
          <p><a className="font-medium text-white hover:underline" href={b.stock_url} data-testid="footer-stock-link">Browse our cars for sale</a></p>
        </div>
        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-brand-silver">Information</p>
          <p><Link className="font-medium text-white hover:underline" to="/privacy" data-testid="footer-privacy-link">Privacy information</Link></p>
          <p><Link className="font-medium text-white hover:underline" to="/valuation-terms" data-testid="footer-terms-link">Valuation terms</Link></p>
          <p><Link className="text-slate-400 hover:text-white" to="/dealer" data-testid="footer-staff-link">Staff sign in</Link></p>
        </div>
      </div>
      {b.legal_line && <p className="mx-auto max-w-6xl border-t border-white/10 px-4 pt-6 text-xs text-slate-300 sm:px-6" data-testid="footer-legal-line">{b.legal_line}</p>}
      <p className="mx-auto max-w-6xl px-4 py-6 text-xs text-slate-400 sm:px-6">
        Online estimates are indicative only. Any offer is made after we review your details and inspect the vehicle.
      </p>
    </footer>
  );
};
